export abstract class GoogleSheetUploadFacade {
  abstract launchDialog(): void;
}
